import React, { FunctionComponent } from 'react';
import { Card, Col, Heading, Paragraph, Text } from '@mlc/web-ui-toolkit';
import { PlanProfile } from '../../../../logic/domains/planProfile.domain';
import {
	asFormattedDate,
	asCurrency,
	asNumber,
} from '../../../common/formatter';

import { TitleRow, SummaryRow } from './styled';
import planProfileTestIds from './PlanProfile.elements';

type Props = {
	planProfile: PlanProfile;
};

const PlanProfileSummary: FunctionComponent<Props> = ({ planProfile }) => {
	return (
		<Card margin={3}>
			<TitleRow justifyContent="between">
				<Col col={6}>
					<Heading
						el="h3"
						fontSize="tiny"
						variant="button"
						data-id={planProfileTestIds.productName}
					>
						{planProfile.productName}
					</Heading>
					<Paragraph
						marginTop={1}
						marginBottom={0}
						data-id={planProfileTestIds.planNumber}
					>
						Plan no. {planProfile.planNumber}
					</Paragraph>
				</Col>
				<Col col={6}>
					<Text
						fontSize="tiny"
						fontWeight="semibold"
						textAlign="right"
						display="block"
						el="p"
						data-id={planProfileTestIds.profilePlanBalance}
					>
						{asCurrency(planProfile.planBalance)}
					</Text>
				</Col>
			</TitleRow>
			<SummaryRow justifyContent="between">
				<SummaryColumn
					title="Commencement date"
					value={asFormattedDate(planProfile.commencementDate)}
					id={planProfileTestIds.planCommencementDate}
				/>
				<SummaryColumn
					title="Number of investors"
					value={asNumber(planProfile.numberOfInvestors)}
					withSeparator={true}
					id={planProfileTestIds.planProfileNumberOfInvestors}
				/>
				<SummaryColumn
					title="Plan review date"
					value={
						planProfile.reviewDate
							? asFormattedDate(planProfile.reviewDate)
							: 'Not supplied'
					}
					withSeparator={true}
					id={planProfileTestIds.planReviewDate}
				/>
			</SummaryRow>
		</Card>
	);
};

const SummaryColumn = ({
	title,
	value,
	withSeparator = false,
	id,
}: {
	title: string;
	value: string | number;
	withSeparator?: boolean;
	id?: string;
}) => (
	<Col noGutter col={3}>
		<Card
			marginTop={6}
			borderLeft={withSeparator ? 'mlcBorderThin' : undefined}
			borderColor={withSeparator ? 'mlcDarkGrey60' : undefined}
		>
			<Paragraph
				fontSize="disclaimer"
				margin={0}
				paddingLeft={withSeparator ? 5 : 2}
			>
				{title}
			</Paragraph>
			<Paragraph
				fontWeight="semibold"
				marginTop={1}
				marginBottom={0}
				paddingLeft={withSeparator ? 5 : 2}
				data-id={id}
			>
				{value}
			</Paragraph>
		</Card>
	</Col>
);

export default PlanProfileSummary;
